
import { useState } from "react";
import { Step1 } from "../components/Step1"
import { Step2 } from "../components/Step2"
import { Step3 } from "../components/Step3"
import { useAuthStore } from "@/core/auth/auth.store";
import {  useNavigate } from "react-router-dom";


const Form = () => {
    const navigate = useNavigate();
    const { setUser, user} = useAuthStore()
    const [currentStep, setCurrentStep] = useState(1);

    const [allData, setAllData] = useState({
        // Datos Step 1
        age: 0,
        sex: 1,
        heightCm: 0,
        weightKg: 0,

        // Datos Step 2
        smoking: "",
        bloodPressureMedication: "",
        diabetes: "",
    });

    const nextStep = () => setCurrentStep(prev => prev + 1);
    const prevStep = () => setCurrentStep(prev => prev - 1);

    const updateData = (newData) => {
        setAllData(prev => ({ ...prev, ...newData }));
    };

    return (
        <>
            {currentStep === 1 && (
                <Step1
                    data={allData}
                    onNext={(data) => { updateData(data); nextStep(); }}
                />
            )}
            {currentStep === 2 && (
                <Step2
                    data={allData}
                    onBack={prevStep}
                    onNext={(data) => { updateData(data); nextStep(); }}
                />
            )}
            {currentStep === 3 && (
                <Step3
                    onStart={() => {
                        user.profile = allData
                        setUser(user)
                        sessionStorage.setItem('vitalsProfile', JSON.stringify(allData))
                        console.log("Datos del usuario guardados en el store:", user);
                        navigate("/vitalsscaning", { replace: true });
                    }}
                    onBack={prevStep}
                />
            )}
        </>
    )
}

export { Form }